// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__tZAl2","row":"ProcedureTreatmentSummary_row__tpFXT"};